import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

console.log(window.location.host)
/*富文本编辑图片上传配置*/
const uploadConfig = {
	action:config.uploadImg,// 必填参数 图片上传地址
	methods: 'POST',  // 必填参数 图片上传方式
	name:"file",
	size: 2048 ,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
	accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'  // 可选 可上传的图片格式
};
const uploadConfigs = {
	action:config.uploadImgs,// 必填参数 图片上传地址
	methods: 'POST',  // 必填参数 图片上传方式
	name:"file",
	size: 600000 ,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
	accept: 'video/mp4'  // 可选 可上传的图片格式
};

// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['clean'],
    ['link', 'image','video']
];
function random_string(len) {
	len = len || 32;
	var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
	var maxPos = chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}

function get_suffix(filename) {
	let pos = filename.lastIndexOf('.')
	let suffix = ''
	if (pos != -1) {
		suffix = filename.substring(pos)
	}
	return suffix;
}
const handlers = {
    image: function image() {
        var self = this;
        var fileInput = this.container.querySelector('input.ql-image[type=file]');
        if (fileInput === null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            // 设置图片参数名
            if (uploadConfig.name) {
                fileInput.setAttribute('name', uploadConfig.name);
            }
            // 可设置上传图片的格式
            fileInput.setAttribute('accept', uploadConfig.accept);
            fileInput.classList.add('ql-image');
            // 监听选择文件
            fileInput.addEventListener('change', function () {
                // 创建formData
                var formData = new FormData();
                formData.append(uploadConfig.name, fileInput.files[0]);
                // 如果需要token且存在token
                if (uploadConfig.token) {
                    formData.append('token', uploadConfig.token)
                }
                // 图片上传
                var xhr = new XMLHttpRequest();
                xhr.open(uploadConfig.methods, uploadConfig.action, true);
                // 上传数据成功，会触发
                xhr.onload = function (e) {
                    if (xhr.status === 200) {
                        var res = JSON.parse(xhr.responseText);
                        let length = self.quill.getSelection(true).index;
                        //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。      
							  console.log(res)
                        self.quill.insertEmbed(length, 'image', res.data.src);
                        self.quill.setSelection(length + 1)
                    }
                    fileInput.value = ''
                };
                // 开始上传数据
                xhr.upload.onloadstart = function (e) {
                    fileInput.value = ''
					
                };
                // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
                xhr.upload.onerror = function (e) {
                };
                // 上传数据完成（成功或者失败）时会触发
                xhr.upload.onloadend = function (e) {
                    // console.log('上传结束')
                };
                xhr.send(formData)
            });
            this.container.appendChild(fileInput);
        }
        fileInput.click();
    },
	video: function video() {
	    var self = this;
	    var fileInput = this.container.querySelector('input.ql-video[type=file]');
	    
	    if (fileInput === null) {
	        fileInput = document.createElement('input');
	        fileInput.setAttribute('type', 'file');
	        
	        if (uploadConfigs.name) {
	            fileInput.setAttribute('name', uploadConfigs.name);
	        }
	        
	        fileInput.setAttribute('accept', uploadConfigs.accept);
	        fileInput.classList.add('ql-image');
	        
	        fileInput.addEventListener('change', function () {
	            var file = fileInput.files[0];
	            
	            // 文件验证
	            if (!file) {
	                return;
	            }
	            
	            // 验证文件类型
	            var acceptedTypes = uploadConfigs.accept.split(',').map(type => type.trim());
	            var fileType = file.type;
	            var isValidType = acceptedTypes.some(type => {
	                if (type.startsWith('.')) {
	                    return file.name.toLowerCase().endsWith(type.toLowerCase());
	                } else if (type.includes('/')) {
	                    return fileType === type || fileType.startsWith(type.split('/')[0] + '/');
	                }
	                return false;
	            });
	            
	            if (!isValidType) {
	                alert('只允许上传以下格式的文件: ' + uploadConfigs.accept);
	                fileInput.value = '';
	                return;
	            }
	            
	            // 验证文件大小
	            var maxSizeKB = uploadConfigs.size ||600000;
	            if (file.size > maxSizeKB * 1024) {
	                var maxSizeMB = (maxSizeKB / 1024).toFixed(1);
	                alert('文件大小不能超过 ' + maxSizeMB + 'MB');
	                fileInput.value = '';
	                return;
	            }
	            
	            // 生成时间戳目录
	            function timestampToTime(times) {
	                let time = times[1]
	                let mdy = times[0]
	                mdy = mdy.split('/')
	                let month = parseInt(mdy[0]);
	                let day = parseInt(mdy[1]);
	                let year = parseInt(mdy[2])
	                return year + '-' + month + '-' + day
	            }
	            
	            let time = new Date()
	            let timeNow = timestampToTime(time.toLocaleString('en-US',{hour12: false}).split(" "))
	            
	            // 创建进度条元素
	            var progressContainer = document.createElement('div');
	            progressContainer.style.position = 'fixed';
	            progressContainer.style.top = '50%';
	            progressContainer.style.left = '50%';
	            progressContainer.style.transform = 'translate(-50%, -50%)';
	            progressContainer.style.width = '300px';
	            progressContainer.style.backgroundColor = '#fff';
	            progressContainer.style.padding = '20px';
	            progressContainer.style.borderRadius = '8px';
	            progressContainer.style.boxShadow = '0 0 10px rgba(0,0,0,0.2)';
	            progressContainer.style.zIndex = '9999';
	            
	            var progressBar = document.createElement('div');
	            progressBar.style.width = '100%';
	            progressBar.style.height = '20px';
	            progressBar.style.backgroundColor = '#f0f0f0';
	            progressBar.style.borderRadius = '10px';
	            progressBar.style.overflow = 'hidden';
	            progressBar.style.marginTop = '10px';
	            
	            var progressFill = document.createElement('div');
	            progressFill.style.height = '100%';
	            progressFill.style.backgroundColor = '#4CAF50';
	            progressFill.style.width = '0%';
	            progressFill.style.transition = 'width 0.3s';
	            
	            var progressText = document.createElement('div');
	            progressText.style.textAlign = 'center';
	            progressText.style.marginTop = '10px';
	            progressText.textContent = '获取上传凭证...';
	            
	            progressBar.appendChild(progressFill);
	            progressContainer.appendChild(document.createTextNode('准备上传...'));
	            progressContainer.appendChild(progressBar);
	            progressContainer.appendChild(progressText);
	            document.body.appendChild(progressContainer);
	            
	            // --- 修改开始：使用 GET 请求获取凭证 ---
	            
	            // 1. 构建查询参数
	            const params = new URLSearchParams({
	                dir: 'p5/adsz_school/' + timeNow
	            });
	            
	            // 2. 将查询参数拼接到 URL
	            const urlWithParams = `${uploadConfigs.action}&${params.toString()}`;
	
	            var xhrToken = new XMLHttpRequest();
	            // 3. 使用 GET 方法，并带上完整URL
	            xhrToken.open('GET', urlWithParams, true);
	            
	            xhrToken.onload = function() {
	                if (xhrToken.status === 200) {
	                    var tokenResponse = JSON.parse(xhrToken.responseText);
	                    console.log(tokenResponse);
	                    let suffix = get_suffix(file.name)
	                    // 更新进度条
	                    progressContainer.firstChild.textContent = '视频上传中...';
	                    progressText.textContent = '0%';
	                    
	                    // 创建formData (用于上传到OSS)
	                    var formData = new FormData();
	                    // formData.append('flag',1);
	                    // formData.append('uid','');
	                    // formData.append('dir','p5/ysmy/'+timeNow);
	                    
	                    // 添加凭证信息
	                    if (tokenResponse) {
	                        if (tokenResponse.policy) {
	                            formData.append('policy', tokenResponse.policy);
	                        }
	                         formData.append('name', file.name);
	                         formData.append('success_action_status', '200');
	                        if (tokenResponse.signature) {
	                            formData.append('signature', tokenResponse.signature);
	                        }
	                        if (tokenResponse.accessid) {
	                            formData.append('ossaccessKeyId', tokenResponse.accessid);
								
	                        }
	                        if (tokenResponse.dir) {
	                            formData.append('key', tokenResponse.dir + random_string(16) + suffix);
								// var key=tokenResponse.dir + random_string(16) + suffix;
								// console.log(tokenResponse.dir + random_string(16) + suffix)
	                        }
	                        if (tokenResponse.callback) {
	                            formData.append('callback', tokenResponse.callback);
	                        }
	                        if (tokenResponse.host) {
	                            formData.append('host', tokenResponse.host);
	                        }
							// console.log(file)
							formData.append('file', file); 
	                    }
	                    
	                    if (uploadConfigs.token) {
	                        formData.append('token', uploadConfigs.token);
	                    }
	                     var videoUrl = tokenResponse.host;
						 
	                    // 视频上传
	                    var xhr = new XMLHttpRequest();
	                    xhr.open(uploadConfigs.methods, videoUrl, true);
	                    
	                    // 监听上传进度
	                    xhr.upload.addEventListener('progress', function(e) {
	                        if (e.lengthComputable) {
	                            var percentComplete = Math.round((e.loaded / e.total) * 100);
	                            progressFill.style.width = percentComplete + '%';
	                            progressText.textContent = percentComplete + '%';
	                        }
	                    });
	                    
	                    xhr.onload = function (e) {
							 // console.log(e)
	                        if (xhr.status === 203 || xhr.status === 200) {
	                            // var res = JSON.parse(xhr.responseText);
	                            let length = self.quill.getSelection(true).index;
	                            
	                            var videoUrl = 'https://people.5cy.com/' + formData.get('key');
								// console.log(videoUrl)
	                            // if (typeof videoUrl === 'object' && videoUrl.src) {
	                            //     videoUrl = videoUrl.src;
	                            // }
	                            
	                            self.quill.insertEmbed(length, 'video', videoUrl);
	                            self.quill.setSelection(length + 1);
	                        } else {
	                            alert('上传失败，请重试');
	                        }
	                    };
	                    
	                    xhr.upload.onerror = function (e) {
	                        document.body.removeChild(progressContainer);
	                        alert('上传出错，请重试');
	                    };
	                    
	                    xhr.upload.onloadend = function (e) {
	                        if (document.body.contains(progressContainer)) {
	                            document.body.removeChild(progressContainer);
	                        }
	                    };
	                    
	                    xhr.send(formData);
	                } else {
	                    document.body.removeChild(progressContainer);
	                    alert('获取上传凭证失败，请重试');
	                }
	            };
	            
	            xhrToken.onerror = function() {
	                document.body.removeChild(progressContainer);
	                alert('获取上传凭证失败，请检查网络连接');
	            };
	            
	            // 4. 发送 GET 请求，无需参数
	            xhrToken.send();
	            // --- 修改结束 ---
	        });
	        
	        this.container.appendChild(fileInput);
	    }
	    
	    fileInput.click();
	}
};

export default {
    placeholder: '在此输入...',
    theme: 'snow',  // 主题
    modules: {
        toolbar: {
            container: toolOptions,  // 工具栏选项
            handlers: handlers  // 事件重写
        }
    }
};